/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { AdminDeleteVideoOptions, AdminDeleteVideoStatus200, AdminDeleteVideoStatus422 } from '../models/AdminDeleteVideo'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { adminDeleteVideo } from '../clients/axios/adminDeleteVideo'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const adminDeleteVideoMutationKey = () => [{ url: '/admin/video/:video_id' }] as const

export function adminDeleteVideoMutationOptions<TContext = unknown>(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const mutationKey = adminDeleteVideoMutationKey()
  return mutationOptions<AdminDeleteVideoStatus200, ResponseErrorConfig<AdminDeleteVideoStatus422>, AdminDeleteVideoOptions, TContext>({
    mutationKey,
    mutationFn: async({ path }) => {
      return await adminDeleteVideo({ ...config, path, throwOnError: true })
    },
  })
}

/**
 * @description Delete a video
 * @summary Delete Video
 * {@link /admin/video/:video_id}
 */
export function useAdminDeleteVideo<TContext>(options: {
  mutation?: UseMutationOptions<AdminDeleteVideoStatus200, ResponseErrorConfig<AdminDeleteVideoStatus422>, AdminDeleteVideoOptions, TContext> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>,
} = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? adminDeleteVideoMutationKey()

  const baseOptions = adminDeleteVideoMutationOptions(config) as UseMutationOptions<AdminDeleteVideoStatus200, ResponseErrorConfig<AdminDeleteVideoStatus422>, AdminDeleteVideoOptions, TContext>

  return useMutation<AdminDeleteVideoStatus200, ResponseErrorConfig<AdminDeleteVideoStatus422>, AdminDeleteVideoOptions, TContext>({
    ...baseOptions,
    mutationKey,
    ...mutationOptions,
  }, queryClient) as UseMutationResult<AdminDeleteVideoStatus200, ResponseErrorConfig<AdminDeleteVideoStatus422>, AdminDeleteVideoOptions, TContext>
}
